export default "__VITE_ASSET__Cp21s33Y__"